import { render } from "./ButtonNew.vue?vue&type=template&id=5319588a&scoped=true"
import script from "./ButtonNew.vue?vue&type=script&lang=js"
export * from "./ButtonNew.vue?vue&type=script&lang=js"

import "./ButtonNew.vue?vue&type=style&index=0&id=5319588a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5319588a"

export default script